import { Component, OnInit } from "@angular/core";

@Component({
    selector: "app-notified-popup",
    templateUrl: "./notified-popup.component.html",
    styleUrls: ["./notified-popup.component.scss"],
    standalone: false
})
export class NotifiedPopupComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
